(() => {
  const startsAt = Date.parse('2026-10-04T23:45:00+01:00');
  const endsAt = Date.parse('2026-10-06T00:00:00+01:00');
  let queued = false;
  const refresh = () => {
    queued = false;
    const now = Date.now();
    const active = false; // Anniversary promotion ended.
    document.documentElement.classList.toggle('hcx-anniversary-active', active);
    document.querySelectorAll('[data-hcx-anniversary]').forEach((node) => {
      if (active && node.classList?.contains('hcx-anniversary-price')) {
        const priceContainer = node.parentElement;
        const regular = priceContainer.classList.contains('price--on-sale')
          ? priceContainer.querySelector('.price__sale .price-item--sale')
          : priceContainer.querySelector('.price__regular .price-item--regular');
        if (regular) {
          const regularStyle = getComputedStyle(regular);
          node.style.setProperty('--hcx-anniversary-price-size', regularStyle.fontSize);
          node.style.setProperty('--hcx-anniversary-price-weight', regularStyle.fontWeight);
          node.style.setProperty('--hcx-anniversary-price-line-height', regularStyle.lineHeight);
        }
      }
      if (node.hidden === active) node.hidden = !active;
    });
  };
  const queue = () => {
    if (!queued) {
      queued = true;
      requestAnimationFrame(refresh);
    }
  };
  refresh();
  new MutationObserver(queue).observe(document.body, {childList: true, subtree: true});
  document.addEventListener('visibilitychange', queue);
  window.addEventListener('resize', queue);
  document.addEventListener('shopify:section:load', queue);
  setInterval(refresh, 10000);

  const restoreHeader = (header) => {
    const img = header.querySelector('picture img');
    const source = header.querySelector('picture source');
    const responsive = (url, widths) => widths.map((width) => url + '&width=' + width + ' ' + width + 'w').join(', ');
    header.href = header.dataset.hcxFallbackHref;
    header.setAttribute('aria-label', header.dataset.hcxFallbackAlt);
    if (img) {
      img.src = header.dataset.hcxFallbackDesktop;
      img.srcset = responsive(header.dataset.hcxFallbackDesktop, [960, 1440, 1920, 2560, 3200, 3840, 5504]);
      img.alt = header.dataset.hcxFallbackAlt;
    }
    if (source) source.srcset = responsive(header.dataset.hcxFallbackMobile, [390, 750, 1125, 1500]);
    header.querySelector('[data-hcx-anniversary-countdown]')?.remove();
    header.removeAttribute('data-hcx-anniversary-header');
  };
  const tickCountdown = () => {
    const remaining = 0; // Restore any cached anniversary header immediately.
    if (!remaining) {
      document.querySelectorAll('[data-hcx-anniversary-header]').forEach(restoreHeader);
      return;
    }
    const parts = {
      hours: Math.floor(remaining / 3600),
      minutes: Math.floor(remaining / 60) % 60,
      seconds: remaining % 60
    };
    document.querySelectorAll('[data-hcx-anniversary-countdown]').forEach((timer) => {
      Object.entries(parts).forEach(([part, value]) => {
        const node = timer.querySelector('[data-hcx-countdown-' + part + ']');
        const text = String(value).padStart(2, '0');
        if (node && node.textContent !== text) node.textContent = text;
      });
    });
  };
  tickCountdown();
  setInterval(tickCountdown, 1000);
  document.addEventListener('visibilitychange', tickCountdown);
})();
